export default __webpack_public_path__ + "static/nike.url-ffe213986c68c3eef320b5eda94c5c17.svg";